import React from 'react'
import { Col } from 'react-bootstrap'
import injectStyles from 'react-jss'

import { Section, SectionLabel, SectionRow } from 'Components/Section'
import { authorization } from 'Module/Auth/Auth'
import styles from './styles'
import { addCurrencySign } from '../../../../Components/CampaignQuote/util'

const MissionCostsUnstyled = ({ mission, classes }) => {
  return (
    <Section title={'Costs'}>
      <SectionRow>
        <Col xs={3}>
          <SectionLabel>Distribution Cost</SectionLabel>
          {addCurrencySign(
            mission.distributionCostV2 / 100,
            mission.cityPlan.city.country.currencySign,
          )}
        </Col>
        <Col xs={3}>
          <SectionLabel>Printing Cost</SectionLabel>
          {addCurrencySign(
            mission.printingCost / 100,
            mission.cityPlan.city.country.currencySign,
          )}
        </Col>
        {!authorization.isClient() &&
        !authorization.isClientAdmin() &&
        !mission.costPerFlyer ? (
          <Col xs={3} cypress_id="mission-details-pay-adjust-div">
            <SectionLabel>Pay adjustment</SectionLabel>
            {addCurrencySign(
              mission.draftPayAdjustment / 100,
              mission.cityPlan.city.country.currencySign,
            )}
          </Col>
        ) : null}
        {!authorization.isClient() &&
        !authorization.isClientAdmin() &&
        mission.costPerFlyer ? (
          <Col xs={3}>
            <SectionLabel>Cost Per Flyer</SectionLabel>
            {addCurrencySign(
              mission.costPerFlyer,
              mission.cityPlan.city.country.currencySign,
            )}
            <div className={classes.descriptionCostPerFlyer}>
              * “Distribution Cost” will be calculated after mission is
              completed
            </div>
          </Col>
        ) : null}
      </SectionRow>
    </Section>
  )
}

const MissionCosts = injectStyles(styles)(MissionCostsUnstyled)
export { MissionCosts }
